import { render } from "./ItemLink.vue?vue&type=template&id=308bee3e"
import script from "./ItemLink.vue?vue&type=script&lang=js"
export * from "./ItemLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__